const DT_CALIB_DATA_REQUEST = 'DT_CALIB_DATA_REQUEST';
const DT_CALIB_DATA_FETCHING = 'DT_CALIB_DATA_FETCHING';
const DT_CALIB_DATA_FETCHED = 'DT_CALIB_DATA_FETCHED';
const DT_CALIB_DATA_FETCHED_FAILED = 'DT_CALIB_DATA_FETCHED_FAILED';
const DT_QC_DATA_FETCHING = 'DT_QC_DATA_FETCHING';
const DT_QC_DATA_FETCHED = 'DT_QC_DATA_FETCHED';
const DT_QC_DATA_FETCHED_FAILED = 'DT_QC_DATA_FETCHED_FAILED';
const DT_DEVICE_STATE_ADD="DT_DEVICE_STATE_ADD";
const DT_DEVICE_STATE_REMOVE="DT_DEVICE_STATE_REMOVE";

export {
    DT_CALIB_DATA_FETCHED,
    DT_CALIB_DATA_FETCHING,
    DT_CALIB_DATA_FETCHED_FAILED,
    DT_CALIB_DATA_REQUEST,
    DT_QC_DATA_FETCHING,
    DT_QC_DATA_FETCHED,
    DT_QC_DATA_FETCHED_FAILED,
    DT_DEVICE_STATE_ADD,
    DT_DEVICE_STATE_REMOVE
}